import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class MentorMappingGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
      super(
        "Mentor Mapping",
        ROUTE_PATH.mentorMappingList,
        ROUTE_PATH.mapMentor,
        false,
        true,
        8,
        false,
        true,
        ["batch", "branch", "mentor_name", "student_name"],
        true,
        [],
        {
          isDownloadExcel: true,
          excelFileName: "mentor_mapping.xlsx",
          btnLabel: "Download Data",
          headers: [
            { key: "student", value: "student_name" },
            { key: "batch", value: "batch" },
            { key: "branch", value: "branch" },
            { key: "mentorName", value: "mentor_name" },
            { key: "mentorContact", value: "mentor_mobile" },
            { key: "mentorEmail", value: "mentor_email" },
          ],
        },
        false,
        { evalKey: "", evalParam: [1], decisiveParam: false },
        false,
        false,
        false,
        null,
        { evalKey: "is_delete", evalParam: [0], decisiveParam: true },
        false,
        null,
        {
          isPreview: false,
          isPreviewType: "VIDEO",
          isEnvUrl: false,
          linkKey: ["filePath"],
          previewName: "",
        },
        {
          isTabSwitch: false,
          label: "",
          isChecked: false,
        },
        false,
        true,
        true,
        [],
        true,
        { isExtraActions: true, btnLabel: "Mentor Logs" },
        {
          isCheckboxEmit: false,
          emitKey: "",
          checkedKey: "",
          valueKey: "",
        },
        {
          isDownload: false,
          key: "",
          valueKey: "",
        },
        {
          isTabStatus: false,
          label: "",
          isChecked: false,
        },
        false,
        false,
        {
          isPrimary: true,
          isDanger: false,
        },
        "",
        { value: "", isVisible: false },
        false,
        false,
        true,
        { isExtraActions: true, btnLabel: "Change Mentor" },
        { value: "", isVisible: false },
        true,
        { evalKey: "mentorId", evalParam: [0], decisiveParam: false }
      );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const studentName = new Headers('Student Name', 'student_name', false, true, 'text');
        const batch = new Headers('Batch', 'batch', false, true, 'text');
        const branch = new Headers('Branch', 'branch', false, true, 'text');
        const mentorName = new Headers('Mentor Name', 'mentor_name', false, true, 'text');
        const mentorContact = new Headers('Mentor Contact', 'mentor_mobile', false, true, 'text');
        const mentorEmail = new Headers('Mentor Email', 'mentor_email', false, true, 'text');
        // const mentorCompany = new Headers('Company', 'mentorCompany', false, true, 'text');

        headers.push(studentName);
        headers.push(batch);
        headers.push(branch);
        headers.push(mentorName);
        headers.push(mentorContact);
        headers.push(mentorEmail);
        // headers.push(mentorCompany);

        return headers;
    }
}